export class Geom {

    /**
     * 
     * @psee https://stackoverflow.com/questions/27928/calculate-distance-between-two-latitude-longitude-points-haversine-formula
     */
    public static getDistanceInKm(lat1: number, lon1: number, lat2: number, lon2: number): number {
        var R = 6371; // Radius of the earth in km
        var dLat = this.deg2rad(lat2 - lat1);  // deg2rad below
        var dLon = this.deg2rad(lon2 - lon1);
        var a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c; // Distance in km
        return d;
    }

    private static deg2rad(deg: number):number {
        return deg * (Math.PI / 180)
    }

    /**
     * This function returns the coordinate conversion
     * string in DD (Decimal Degrees) to DMS (Degress, Minutes, Seconds).
     * 
     * @param lat Latitude
     * @param lng Longitude
     * @source  http://en.marnoto.com/2014/04/converter-coordenadas-gps.html
     */
    public static ddToDms(lat: number, lng: number, includeSeconds: boolean = false): string {

        var latResult: string;
        var lngResult: string;
        var dmsResult: string;

        latResult = (lat >= 0) ? 'N' : 'S';

        // Call to getDms(lat) function for the coordinates of Latitude in DMS.
        // The result is stored in latResult variable.
        latResult += this.getDms(lat, includeSeconds);

        lngResult = (lng >= 0) ? 'E' : 'W';

        // Call to getDms(lng) function for the coordinates of Longitude in DMS.
        // The result is stored in lngResult variable.
        lngResult += this.getDms(lng, includeSeconds);

        // Joining both variables and separate them with a space.
        dmsResult = latResult + ' ' + lngResult;

        // Return the resultant string
        return dmsResult;
    }

    public static getDms(val: number, includeSeconds: boolean = false): string {

        var valDeg: number;
        var valMin: number;
        var valSec: number;
        var result: string;

        val = Math.abs(val);

        valDeg = Math.floor(val);
        result = valDeg + "°";//"º";

        valMin = Math.floor((val - valDeg) * 60);
        result += valMin;

        if (includeSeconds) {
            result += "'";
            valSec = Math.round((val - valDeg - valMin / 60) * 3600 * 1000) / 1000;
            result += valSec + '"';
        }

        return result;
    }
}